 
import type { CSSProperties, JSX } from 'react';
import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { ErrorIcon, ErrorValidation } from '../ErrorValidation';
import Label from '../Label';
import LabelWrapper from '../LabelWrapper';
import RequireIndicator from '../RequireIndicator';

interface InputProps {
  hasError?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const Input = styled.input<InputProps>`
  width: 100%;
  padding: 10px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--require-border)'
        : 'var(--input-border-normal)'};
`;

interface TextProps {
  fontSize?: string;
}

const Text = styled.p<TextProps>`
  font-size: ${({ fontSize }) =>
    fontSize ? fontSize : '12px'};
  font-weight: bold;
  color: #000;
  margin-bottom: 4px;
`;

interface VanillaInputProps {
  name?: string;
  required?: boolean;
  type?: string;
  label?: string;
  placeholder?: string;
  hasGroupError?: boolean;
  onChange?: (event: React.FocusEvent<HTMLInputElement>) => void;
  customStyles?: CSSProperties;
  isError?: boolean;
  isTouched?: boolean;
  errorMessage?: string;
  value?: string;
  disabled?: boolean;
}

function VanillaInput({
  name,
  required,
  type,
  label,
  placeholder,
  hasGroupError,
  onChange: handleOnBlur,
  customStyles,
  isError,
  isTouched,
  errorMessage,
  value: inputValue,
  disabled
}: VanillaInputProps): JSX.Element {
  const [value, setValue] = useState(inputValue || '');

  useEffect(() => {
    setValue(inputValue || '');
  }, [inputValue]);

  function onBlur(
    event: React.FocusEvent<HTMLInputElement>
  ) {
    if (value !== inputValue && handleOnBlur) {
      handleOnBlur(event);
    }
  }

  return (
    <Wrapper style={customStyles}>
      {label && (
        <LabelWrapper>
          {required && !disabled && (
            <RequireIndicator />
          )}
          <Label>{label || ''}</Label>
        </LabelWrapper>
      )}

      {disabled && !isError ? (
        <Text>{value}</Text>
      ) : (
        <Input
          type={type}
          name={name}
          hasError={
            (isError && isTouched) || hasGroupError
          }
          onBlur={onBlur}
          value={value}
          placeholder={placeholder}
          onChange={event =>
            setValue(event.target.value)
          }
        />
      )}

      {isError && isTouched && (
        <ErrorValidation>
          <ErrorIcon />
          <p>{errorMessage}</p>
        </ErrorValidation>
      )}
    </Wrapper>
  );
}

export default VanillaInput;